import { render } from "./DepositTransferHistoryTable.vue?vue&type=template&id=b3dad80c&scoped=true&ts=true"
import script from "./DepositTransferHistoryTable.vue?vue&type=script&lang=ts"
export * from "./DepositTransferHistoryTable.vue?vue&type=script&lang=ts"

import "./DepositTransferHistoryTable.vue?vue&type=style&index=0&id=b3dad80c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3dad80c"]])

export default __exports__